<template>
    <mercur-card class="full-height-layout fill mx-4 mb-3">
        <grid-header :quickSearch.sync="filters.search">
            <template slot="smallHeader">
                Stock levels
            </template>
            <template slot="actions">
                <mercur-button :to="backRoute" class="btn btn-default mt-2">
                    <i class="fas fa-chevron-left"></i>
                    <span>Go back to list</span>
                </mercur-button>
            </template>
        </grid-header>

        <template v-if="url">
            <data-table
                class="fill full-height-layout border"
                :options="options"
                :url="url"
                :quickSearch="filters.search"
                ref="table"
            />
        </template>
        <div>
            <mercur-dialog :is-open.sync="dialog.isOpen" width="600px">
                <template v-if="dialog.title" slot="header">
                    <h3>{{dialog.title}}</h3>
                </template>
                <p v-if="dialog.content">{{dialog.content}}</p>
                <div v-if="dialog.attributes">
                    <p><b>Attribute configuration:</b></p>
                    <span v-for="(attributeValue, attributeName) in dialog.attributes" :key="attributeName">
                        {{ attributeName | beautify }}: {{ attributeValue }}
                        <br/>
                    </span>
                </div>
                <div v-if="dialog.supplierReferences" class="mt-4">
                    <p><b>Supplier references:</b></p>
                    <span v-for="reference in dialog.supplierReferences" :key="reference">
                        {{ reference }}
                        <br/>
                    </span>
                </div>
                <template slot="footer">
                    <mercur-button class="btn" @click="dialog.isOpen = false">Cancel</mercur-button>
                    <mercur-button class="btn btn-raised btn-primary" v-if="dialog.action" @click="dialog.action">Confirm</mercur-button>
                </template>
            </mercur-dialog>
        </div>
    </mercur-card>
</template>
<script>

import CONFIG from '@root/config'
import DataTable from '@/components/DataTable'
import GridHeader from '@/components/GridHeader.vue'

export default {
    name: 'StockLevelConfigurationsStockLevels',
    components: { GridHeader, DataTable },
    data () {
        return {
            dialog: {
                isOpen: false,
                action: () => {},
            },
            isLoading: false,
            options: {
                columns: {
                    'SKU': {
                        field: 'supplierSku',
                        sortable: true,
                    },
                    'Stock level': {
                        field: 'stockLevel',
                        sortable: true,
                    },
                    'Stock facility': {
                        field: 'facility',
                        sortable: true,
                        width: 150,
                    },
                    'Back in stock': {
                        field: 'dateBackInStock',
                        sortable: true,
                    },
                    'Updated': {
                        field: 'dateUpdated',
                        sortable: true,
                    },
                },
                actions: [
                    {
                        text: 'Details',
                        icon: 'fas fa-eye',
                        onClick: ({ data }) => this.showDetails(data),
                        disabled: () => this.isLoading,
                    },
                ],
                quickSearchColumns: ['supplierSku'],
                sortModel: [
                    {
                        colId: 'dateUpdated',
                        sort: 'desc',
                    },
                ],
                paginationPageSize: 25,
                cacheBlockSize: 25,
            },
            filters: {
                search: '',
            },
        }
    },
    computed: {
        url () {
            return CONFIG.API.ROUTES
                .SUPPLIERS.STOCK_LEVEL_CONFIGURATIONS.LIST_STOCK_LEVELS
                .replace('{supplierId}', this.supplierId)
                .replace('{stockLevelConfigurationId}', this.$route.params.stockLevelConfigurationId)
        },
        backRoute () {
            return {
                name: 'SupplierStockLevelConfigurations',
                params: {
                    supplierId: this.supplierId,
                },
            }
        },
    },
    methods: {
        showDetails (data) {
            this.dialog = {
                isOpen: true,
                title: 'Supplier SKU details',
                attributes: data.attributes,
                supplierReferences: data.supplierReferences,
            }
        },
    },
    created () {},
}
</script>
